import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import type { Location, RouterActionPush } from '@atlassian/react-resource-router';
import { removeSelectedIssueFromUrl } from '../../services/routing/selected-issue-url-change';
import { SET_APP_DATA } from '../../state/actions/app';
import { cardAutoScroll } from '../../state/actions/cards/auto-scroll';
import { cardSingleSelect, SET_LAST_SELECTED_CARD_KEY } from '../../state/actions/cards/selection';
import { openDetailView } from '../../state/actions/detail-view';
import { LOAD_ISSUE_PARENTS_SUCCESS } from '../../state/actions/issue-parents/load';
import { getLastSelectedCardKey, getIdByKeyForAllIssueTypes } from '../../state/selectors/cards';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types';

const performSelectedKeyCheck =
	(store: MiddlewareAPI, location: Location, push: RouterActionPush) => () => {
		const state = store.getState();
		const lastSelectedCardKeyFromUrl = getLastSelectedCardKey(state);

		if (lastSelectedCardKeyFromUrl) {
			const cardId = getIdByKeyForAllIssueTypes(state)(lastSelectedCardKeyFromUrl);
			if (cardId) {
				return Observable.from([
					cardSingleSelect(cardId),
					openDetailView(cardId),
					cardAutoScroll(cardId),
				]);
			}

			push(removeSelectedIssueFromUrl(location));
		}

		return Observable.empty<never>();
	};

// there are two cases, when we need to read lastSelectedCardKey from URL and open Bento on Backlog init
// 1) When critical path data is loaded before App routing initialised (with SSR/SPA) -> postLocationSetEpic
// 2) When critical path data is loaded after App routing initialised (without SSR) -> setSelectedIssueFromUrlEpic

const observables = (action$: ActionsObservable, isCompanyManaged: boolean) =>
	isCompanyManaged
		? [
				action$.ofType(SET_LAST_SELECTED_CARD_KEY).first(),
				action$.ofType(SET_APP_DATA).first(),
				action$.ofType(LOAD_ISSUE_PARENTS_SUCCESS).first(),
			]
		: [action$.ofType(SET_LAST_SELECTED_CARD_KEY).first(), action$.ofType(SET_APP_DATA).first()];

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (getLocation: () => Location, push: RouterActionPush, isCompanyManaged: boolean) =>
	(action$: ActionsObservable, store: MiddlewareAPI) =>
		Observable.forkJoin(observables(action$, isCompanyManaged))
			.mergeMap(performSelectedKeyCheck(store, getLocation(), push))
			.catch(() => Observable.empty<never>());
